<div id="analytics-container" class="analytics-container" [class.program-mode]="programsMode" *loading="loadStatus">
  <div class="top-bar">
    <user-search [initialValue]="search" (searchChange)="searchSessions($event)"></user-search>
    <button mat-button (click)="exportStats()">
      <mat-icon svgIcon="download" *ngIf="!programsMode"></mat-icon>
      <mat-icon fontSet="fa" fontIcon="fa-cloud-download" *ngIf="programsMode"></mat-icon>
      <span>{{ programsMode ? 'EXPORT SESSIONS' : 'Export' }}</span>
    </button>
  </div>

  <table #table mat-table matSort (matSortChange)="sortData($event)" *ngIf="dataSource" [dataSource]="dataSource">
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="date-col">Date</th>
      <td mat-cell *matCellDef="let session" class="date-col">{{ session.date | date : 'medium' }}</td>
    </ng-container>
    <ng-container matColumnDef="actor_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let session">
        <span [ngClass]="{ 'link': !programsMode }" (click)="goToDetails(session)">{{ formatActor(session.actor_name) }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Time spent</th>
      <td mat-cell *matCellDef="let session">{{ session.duration | durationConverter }}</td>
    </ng-container>
    <ng-container matColumnDef="sceneViews">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Scene Viewed</th>
      <td mat-cell *matCellDef="let session">{{ session.sceneViews }}</td>
    </ng-container>
    <ng-container matColumnDef="completed">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Completed</th>
      <td mat-cell *matCellDef="let session">
        <mat-icon>{{ session.completed ? 'done' : 'remove' }} </mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Score</th>
      <td mat-cell *matCellDef="let session">{{ session.score }}</td>
    </ng-container>
    <ng-container matColumnDef="multi">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let session">{{ session.multisession ? 'Co-viewing' : 'Solo' }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
      <td mat-cell *matCellDef="let session">
        <span class="link" (click)="goToDetails(session)"> Open Logs </span>
        <span class="link" (click)="exportLogs(session)"> Export </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <div *ngIf="noData" class="nodata">No data available</div>
</div>
